import axios from 'axios';
import { ROOT_DIR, MONTHS } from './Constants';

function getEvents(cb){
  axios.get(`${ROOT_DIR}/data/events.json`, {
    
  })
  .then(function (response) {
    var newArr = [];
    var today = new Date();
    var currMonth = MONTHS[today.getMonth()];
    var currYear = today.getFullYear();
    response.data.forEach((val, idx) => {
      // filter out past dates?
      var eventDate = new Date(val.Day + ' ' + val.Month + ' ' + val.Year);
      var eventTimeMS = eventDate.getTime();
      val.system_date = eventDate;
      val.event_time = eventTimeMS;
      if(today < eventDate || eventDate.setHours(0,0,0,0) == today.setHours(0,0,0,0)) {
        newArr.push(val);
      }
    });
    cb(response.data, currMonth, currYear);
  })
  .catch(function (error) {
    console.log(error.message);
  });
}

function getMedia(cb, file){
  axios.get(`${ROOT_DIR}/data/${file}.json`, {
    
  })
  .then(function (response) {
    
    cb(response.data);
  })
  .catch(function (error) {
    console.log(error.message);
  });
}


const Client = { getEvents, getMedia };
export default Client;


// WEBPACK FOOTER //
// ./src/utils/Client.js